import { gql } from '@apollo/client';

export const GET_COMPETITORS = gql(/* GraphQL */ `
    query GetCompetitors($competitorFilterInput: CompetitorFilterInput!) {
        getCompetitors(competitorFilterInput: $competitorFilterInput) {
            id
            storeId
            advertisingZoneId
            name
            address
            email
            isMajor
            telNo {
                countryCode
                dialingCode
                number
            }
        }
    }
`);

export const CREATE_COMPETITOR = gql(/* GraphQL */ `
    mutation CreateCompetitor($input: CreateCompetitorInput!) {
        createCompetitor(createCompetitorInput: $input) {
            id
            name
            isMajor
            advertisingZoneId
            address
            email
            telNo {
                countryCode
                dialingCode
                number
            }
        }
    }
`);
